import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M7 4h17v33H11v-2h11V6H9v6H7V4Zm27 11h-8v-2h5v-2h-5V9h7v4h3v24H26v-2h8V15Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14 9h-2v5h2V9Zm3 0h2v5h-2V9Zm2 9h-2v5h2v-5Zm-2 9h2v5h-2v-5Zm14-10h-2v5h2v-5Zm-2 9h2v5h-2v-5Z"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 14a1.95 1.95 0 0 0-1.833 1.287L2.395 25.706a5.489 5.489 0 0 0 2.617 6.732A4.941 4.941 0 0 0 7 32.99V37h2v-4.01a4.941 4.941 0 0 0 1.99-.553 5.489 5.489 0 0 0 2.616-6.732L9.834 15.287A1.95 1.95 0 0 0 8 14ZM4.276 26.388 8 16.097l3.725 10.29a3.489 3.489 0 0 1-1.663 4.278c-.42.22-.889.335-1.364.335H7.303c-.475 0-.943-.114-1.364-.335a3.489 3.489 0 0 1-1.663-4.278Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const PictogramBuildingBuilding40 = createIcon(IconComponent);